import type { CityConfig } from "../city-template/types";

export const dickinsonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Dickinson",
  state: "North Dakota",
  stateAbbr: "ND",
  slug: "dickinson",
  route: "/cities/dickinson",
  title: "Emergency Passport Dickinson, ND — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Dickinson, ND — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Dickinson, Dickinson State University, Theodore Roosevelt National Park travelers, and Stark County. No Minneapolis trip needed.",
  h1: "Emergency & Expedited Passport Services in Dickinson, ND",
  heroSubtitle: "DSU international student heading home for break? Energy sector professional with a Calgary meeting? Theodore Roosevelt National Park visitor needing emergency passport services? We help Dickinson residents — from Blue Hawks students to Bakken support businesses to Badlands adventurers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30-100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20Dickinson%20North%20Dakota%20skyline%20with%20the%20Badlands%20landscape%20in%20the%20background%20and%20Heart%20River%20winding%20through%20town%2C%20historic%20downtown%20buildings%20and%20Dickinson%20State%20University%20campus%20visible%2C%20dramatic%20North%20Dakota%20big%20sky%20at%20golden%20hour%20with%20warm%20amber%20light%20over%20the%20western%20prairie%2C%20editorial%20travel%20photography%20with%20crisp%20detail%20and%20natural%20colors&width=1800&height=700&seq=dickinson-hero-2026&orientation=landscape",
  heroImageAlt: "Dickinson North Dakota skyline with Badlands and Heart River at golden hour",
  geoPosition: "46.8792;-102.7896",
  geoPlacename: "Dickinson, North Dakota",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Nearest regional passport agency — located approximately 640 miles from Dickinson; completely impractical for Stark County residents",
  },
  nearbyCitiesZips: [
    { name: "Dickinson", zips: "58601, 58602" },
    { name: "Belfield", zips: "58622" },
    { name: "South Heart", zips: "58655" },
    { name: "New England", zips: "58647" },
    { name: "Killdeer", zips: "58640" },
    { name: "Richardton", zips: "58652" },
    { name: "Beach", zips: "58621" },
    { name: "Glendive, MT", zips: "59330" },
  ],
  benefits: [
    { icon: "ri-graduation-cap-line", title: "DSU International Student Support", desc: "Dickinson State University attracts international students from across the globe. We expedite passports for study abroad, international student travel home, and DSU-sponsored global programs — understanding academic calendar deadlines." },
    { icon: "ri-landscape-line", title: "Theodore Roosevelt National Park Gateway", desc: "Dickinson is the gateway to Theodore Roosevelt National Park's South Unit — attracting international visitors who sometimes need emergency passport services while traveling. We assist with urgent replacements for visitors far from home." },
    { icon: "ri-oil-line", title: "Western ND Energy Hub", desc: "Dickinson serves as a support hub for the Bakken — energy professionals travel to Canada, the Middle East, and Europe for equipment, conferences, and partnerships. We understand energy sector timing." },
    { icon: "ri-building-2-line", title: "No Minneapolis Trip Needed", desc: "Minneapolis Passport Agency is 640 miles from Dickinson — a 9+ hour drive. Our registered courier service handles everything remotely so you never leave western North Dakota." },
  ],
  internalLinks: [
    { name: "Expedited passport in Bismarck, ND", route: "/cities/bismarck" },
    { name: "Fast passport services in Williston, ND", route: "/cities/williston" },
    { name: "Quick passport services in Minot, ND", route: "/cities/minot" },
    { name: "Urgent passport services in Mandan, ND", route: "/cities/mandan" },
    { name: "North Dakota passport services overview", route: "/states/north-dakota" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Dickinson via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 9+ hours to Minnesota. Dickinson residents can ship from any UPS Store, FedEx Office, or post office location across Stark County.",
  fpcOfficeDistance: "Serving Dickinson, Belfield, South Heart, New England, Killdeer, Richardton, Beach, Glendive MT, and all Stark County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Dickinson and the Badlands region. From the DSU campus to the Bakken support businesses, from the historic downtown to I-94 travelers — we serve all of Stark County. Our courier service eliminates the impossible drive to Minneapolis for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Dickinson and all Stark County communities including Belfield, South Heart, and Richardton. We also serve Bakken support workers throughout the region, DSU international students, and visitors to Theodore Roosevelt National Park.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Dickinson as simple as possible — with the efficiency western North Dakotans expect. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Dickinson travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Dickinson's university town character combined with its energy support role and national park tourism creates unique passport situations. Here are the most common mistakes we see from this area.",
  testimonialsIntro: "Dickinson travelers — from DSU Blue Hawks studying abroad to Badlands visitors needing emergency replacements to energy support professionals — trust us when international travel can't wait and Minneapolis is out of the question.",
  faqIntro: "Have questions about expedited passports in Dickinson, ND? Here are the most common ones we hear from Stark County and Badlands region travelers.",
  statePageRoute: "/states/north-dakota",
  statePageName: "North Dakota",
  servicesIntro: "Whether you're a DSU student preparing for study abroad, a Bakken support professional heading to Canada, or a Badlands visitor needing an emergency passport replacement — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30-100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dot.nd.gov/divisions/driverslicense/driverslicense.htm",
  dmvLabel: "North Dakota Department of Transportation — Driver License Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2-9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Minneapolis trip needed", "Ideal for DSU study abroad and Bakken travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3-5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1-3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Dickinson", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 640 miles from Dickinson", "Completely impractical for Stark County residents"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "DSU student with a family emergency back home abroad? National park visitor who lost their passport? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Dickinson travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Dickinson residents renew fast — no agency visit required for most renewals. Perfect for DSU faculty, energy professionals, and Stark County families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Stark County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Lost your passport while visiting Theodore Roosevelt National Park? Replacements require additional forms. We guide you through everything needed so your Badlands adventure isn't ruined.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Dickinson family vacation stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for DSU international program coordinators and energy professionals with overlapping visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-global-line",
      title: "International Student Passport",
      description: "DSU international students needing U.S. passport services while studying in Dickinson — we help with renewals, replacements, and emergency processing for non-citizen residents.",
      bullets: ["International student support", "Foreign national guidance", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada. Ideal for Dickinson energy workers crossing into Saskatchewan for equipment and meetings.",
      bullets: ["Wallet-size convenience", "Land crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Dickinson ND", description: "Urgent passport processing for Dickinson North Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Dickinson ND", description: "Fast passport renewal for Dickinson North Dakota residents." },
    { name: "First-Time Passport Dickinson ND", description: "New passport application services for Dickinson North Dakota first-time applicants." },
    { name: "Child Passport Dickinson ND", description: "Minor passport services for Dickinson North Dakota families with children under 16." },
    { name: "Name Change Passport Dickinson ND", description: "Passport name correction for Dickinson residents after marriage or legal name changes." },
    { name: "International Student Passport Dickinson ND", description: "Passport services for Dickinson State University international students." },
  ],
  testimonials: [
    {
      name: "Professor Alan K.",
      location: "Dickinson",
      rating: 5,
      text: "I lead DSU's international business program and travel to Asia twice a year for university partnerships. When my passport renewal fell through the cracks between semesters, Fast Passport Center got it back to me in 6 days. Didn't miss a single class or the China trip.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Rachel M.",
      location: "Dickinson",
      rating: 5,
      text: "We were camping in Theodore Roosevelt National Park when I realized my passport was missing — probably fell out of my bag on a hike. We had a trip to Banff in Canada planned for 2 weeks later. Fast Passport Center processed an emergency replacement and had it to our Dickinson address in 4 days.",
      service: "Lost Passport — Emergency Replacement",
    },
    {
      name: "Carlos V.",
      location: "Dickinson",
      rating: 5,
      text: "Bakken logistics coordinator — my company sent me to Calgary to negotiate equipment contracts on 8 days' notice. My passport had expired and I'd just moved to Dickinson from Texas. Fast Passport Center handled everything remotely, including documentation from my previous state. Passport arrived day 6.",
      service: "Expedited Passport — Canada Business",
    },
    {
      name: "Emily S.",
      location: "Belfield",
      rating: 5,
      text: "My daughter is a DSU student doing a semester in Spain. Her renewal needed to be processed during spring break when she was home — tight 10-day window. Fast Passport Center understood the academic timeline and delivered. She's in Barcelona now.",
      service: "Passport Renewal — Study Abroad",
    },
  ],
  facilities: [
    {
      id: "dickinson-1",
      name: "Dickinson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15 1st St E",
      city: "Dickinson",
      state: "ND",
      zip: "58601",
      phone: "(701) 225-2715",
      hours: "Mon-Fri 9:00 AM - 3:30 PM (appointment required)",
      distance: "Downtown Dickinson",
      website: "https://tools.usps.com/find-location.htm?location=1376550",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Stark County. Passport photos available on-site. Appointment recommended — limited slots in western North Dakota.",
      icon: "ri-mail-line",
    },
    {
      id: "dickinson-2",
      name: "Stark County Clerk of Court",
      type: "County Clerk Passport Acceptance",
      address: "51 3rd St E",
      city: "Dickinson",
      state: "ND",
      zip: "58601",
      phone: "(701) 456-7640",
      hours: "Mon-Fri 8:00 AM - 4:30 PM",
      distance: "Downtown Dickinson — Stark County Courthouse",
      website: "https://www.starkcountynd.gov/",
      websiteLabel: "Stark County Website",
      notes: "Alternative to post office acceptance. Appointment recommended. Does not offer photo services — bring your own passport photo.",
      icon: "ri-government-line",
    },
    {
      id: "dickinson-3",
      name: "Belfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "210 Main St N",
      city: "Belfield",
      state: "ND",
      zip: "58622",
      phone: "(701) 575-4275",
      hours: "Mon-Fri 9:00 AM - 3:00 PM (appointment required)",
      distance: "Belfield — about 22 miles west of Dickinson on I-94",
      website: "https://tools.usps.com/find-location.htm?location=1372819",
      websiteLabel: "USPS Location",
      notes: "Serves western Stark County and Billings County. Small facility — call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "dickinson-4",
      name: "Beach Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "155 Central Ave S",
      city: "Beach",
      state: "ND",
      zip: "58621",
      phone: "(701) 872-4211",
      hours: "Mon-Fri 9:00 AM - 3:00 PM (appointment required)",
      distance: "Beach — about 60 miles west of Dickinson near the Montana border",
      website: "https://tools.usps.com/find-location.htm?location=1372816",
      websiteLabel: "USPS Location",
      notes: "Westernmost acceptance facility in North Dakota. Serves Golden Valley County and far western Stark County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "dickinson-5",
      name: "Glendive Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "221 N Kendrick Ave",
      city: "Glendive",
      state: "MT",
      zip: "59330",
      phone: "(406) 377-3400",
      hours: "Mon-Fri 9:00 AM - 3:30 PM (appointment required)",
      distance: "Glendive, MT — about 95 miles west of Dickinson on I-94",
      website: "https://tools.usps.com/find-location.htm?location=1375567",
      websiteLabel: "USPS Location",
      notes: "Montana-side option for Dickinson residents in the far western part of the service area. Serves Dawson County, MT.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 640 miles and 9+ hour drive from Dickinson", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Minneapolis; impossible day trip from Dickinson", fpc: "Most Dickinson travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — completely impractical from western ND", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Dickinson", agency: "640-mile drive one way — 9+ hours; essentially impossible", fpc: "Entirely remote — forms online, ship from Dickinson, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in impossible travel to Minneapolis", fpc: "Best price guarantee — 30-100% less than FedEx, Staples and resellers" },
    { feature: "Dickinson Context", agency: "No DSU, Badlands, or energy support expertise", fpc: "Full Dickinson knowledge — DSU, Theodore Roosevelt NP, Bakken support, rural ND" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "DSU International Student Passport Confusion",
      description: "Dickinson State University's international student population creates unique passport situations. Students from other countries studying at DSU may have passport needs related to their home country documents, U.S. visas, and travel between countries. We provide guidance specific to international students in western North Dakota.",
    },
    {
      icon: "ri-error-warning-line",
      title: "National Park Visitor Passport Emergencies",
      description: "Theodore Roosevelt National Park attracts visitors from around the world. Lost, stolen, or damaged passports during a national park visit are more common than you'd think — hiking, camping, and travel create situations where passports go missing. We process emergency replacements for park visitors stranded far from home.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Rural Mail Timing in Western ND",
      description: "Rural Stark County mail routes can add 3-5 extra days for standard delivery. For Dickinson residents with international travel deadlines — whether DSU academic dates or energy sector meetings — this is too slow. Our overnight courier channel eliminates rural mail delays entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "I-94 Traveler Passport Emergencies",
      description: "Dickinson sits on I-94, a major cross-country route. Travelers passing through sometimes discover passport issues en route to Canada or returning from international trips. We help interstate travelers who find themselves stuck in Dickinson with a passport emergency.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Bakken Support Business International Travel",
      description: "Dickinson businesses that support the Bakken — equipment suppliers, logistics companies, engineering firms — regularly send staff to Canada and beyond. Many don't maintain current passports because international travel is sporadic. When a trip comes up, the rush is real. We recommend support businesses keep key staff passports current proactively.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether it's a DSU study abroad deadline, Bakken business trip, or Badlands vacation." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist — whether you're a DSU student, energy professional, or Stark County family." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send documents using overnight shipping. Most Dickinson clients ship from the UPS Store on 3rd Ave W or the Dickinson Post Office — no Minneapolis trip needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our center. We submit through reserved agency slots — so Dickinson travelers never need to drive 640 miles to Minneapolis." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is shipped directly to your Dickinson address — whether that's on the DSU campus, downtown, or a ranch outside town. No agency visit. No Minneapolis. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Dickinson, North Dakota?", a: "We offer Dickinson area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5-10 business days. Because the nearest regional passport agency is in Minneapolis (640 miles away), our remote courier service is the only practical fast option in western North Dakota." },
    { q: "Do I need to visit a Dickinson office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Dickinson Post Office or Stark County Clerk), then ship documents overnight. We handle State Department submission and return your passport to your Stark County address." },
    { q: "Can DSU international students get passport help in Dickinson?", a: "Yes. Dickinson State University's international student population has unique passport needs. While we primarily process U.S. passports, we provide guidance for international students navigating passport renewals from their home countries while studying in Dickinson, including document requirements and processing timelines." },
    { q: "What if I lost my passport at Theodore Roosevelt National Park?", a: "This happens more often than you'd think. Report the loss immediately, then we guide you through the DS-64 lost passport form and replacement processing. As an emergency, we can expedite your replacement passport in as fast as 24 hours — getting you back on the road or to your international destination." },
    { q: "What is the best price for expedited passport service in Dickinson?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30-100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "What documents do Dickinson applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. DSU students with out-of-state documents: we provide extra guidance." },
    { q: "Can I get a passport photo in Dickinson?", a: "Yes. The Dickinson Post Office offers on-site passport photos. Walgreens and Walmart in Dickinson also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does rural mail affect passport processing from Dickinson?", a: "Rural Stark County delivery can add 3-5 days to standard mail timelines. We use overnight courier shipping exclusively — your documents arrive the next business day regardless of rural route delays. For time-sensitive DSU academic travel or Bakken business trips, this is essential." },
    { q: "Can you help with passports for Canadian energy business trips from Dickinson?", a: "Yes. Dickinson businesses supporting the Bakken frequently send staff to Saskatchewan and Alberta. Canada requires valid passports or passport cards for entry. We expedite both types. A passport card is often sufficient for land crossings and processes faster." },
    { q: "Is there an airport in Dickinson for international connections?", a: "Dickinson Theodore Roosevelt Regional Airport (DIK) offers daily United flights to Denver. International travelers connect through Denver International Airport. Your passport must be valid at DIK check-in — the airline verifies documents before you board your Denver connection." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Dickinson Residents",
    intro: "Dickinson's role as a university town, Badlands gateway, and Bakken support hub creates unique passport timing needs. Here's what Stark County travelers need to know.",
    cards: [
      {
        icon: "ri-graduation-cap-line",
        title: "DSU — International Programs & Study Abroad",
        subtitle: "Dickinson State University drives international travel",
        description: "Dickinson State's international programs send students to Europe, Asia, and South America each semester. Faculty travel for research collaborations and academic conferences. DSU's international student body — representing dozens of countries — creates year-round passport and travel document needs with fixed academic calendar deadlines.",
        tip: "DSU students should begin passport processing the semester before planned study abroad. Many programs require 6 months of passport validity beyond the program end date — a detail that catches many students off guard during application season.",
      },
      {
        icon: "ri-landscape-line",
        title: "Theodore Roosevelt National Park Tourism",
        subtitle: "International visitors in the Badlands",
        description: "Theodore Roosevelt National Park's South Unit entrance is just outside Dickinson, bringing international tourists to Stark County year-round. When visitors lose passports during park adventures or discover expired documents while traveling, Dickinson becomes their emergency services hub. Our courier service can process replacements while travelers continue their journey.",
        tip: "International visitors to the Badlands should keep passports in a secure, waterproof location separate from daily hiking gear. A photocopy stored separately can also speed up replacement processing if the original is lost.",
      },
      {
        icon: "ri-oil-line",
        title: "Bakken Support Industry Travel",
        subtitle: "Energy sector professionals in a support hub role",
        description: "Dickinson businesses supply the Bakken with equipment, logistics, engineering, and professional services. Staff regularly travel to Calgary, Edmonton, and international energy hubs. Unlike Williston's direct field operations, Dickinson's support role means more scheduled business travel — but still on energy industry timelines that demand speed.",
        tip: "Bakken support businesses should identify key staff who may need international travel and ensure their passports are current. Proactive passport management prevents the scramble when a Canadian equipment supplier needs an in-person visit next week.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "DIK — Dickinson Theodore Roosevelt Regional Airport",
        subtitle: "Local air connections to the world",
        description: "DIK offers daily United Airlines flights to Denver International Airport — the gateway to global destinations. The airport is named after Theodore Roosevelt himself, reflecting Dickinson's deep connection to the national park and the conservation president. Most Dickinson international travelers connect through Denver for overseas flights.",
        tip: "DIK check-in agents verify passport validity before boarding. Your international trip begins at the Dickinson airport counter — make sure your passport is valid before you arrive.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Dickinson & I-94 — The Northern Tier Corridor",
      description: "Dickinson sits on I-94, the major northern transcontinental route connecting the Great Lakes to the Pacific Northwest. This positioning makes Dickinson a natural stop for cross-country travelers — and sometimes, the place where passport emergencies get resolved. Our courier service can process urgent passports for travelers passing through, getting them back on the road with minimal delay.",
    },
  },
  destinations: {
    title: "Where Dickinson Travelers Go — And Why Passports Get Urgent",
    intro: "Dickinson's university, energy, and tourism identity shapes its international travel patterns.",
    stats: [
      { stat: "30%", label: "of Dickinson expedited requests involve DSU study abroad and academic travel" },
      { stat: "2-4 Weeks", label: "average lead time for Bakken support business international trips" },
      { stat: "Aug & Jan", label: "peak seasons for DSU semester abroad departures" },
      { stat: "640 Miles", label: "distance to nearest passport agency — our courier makes it possible" },
    ],
    destinations: [
      { name: "Canada", context: "Bakken support equipment sourcing in Saskatchewan and Alberta, Calgary and Edmonton business meetings, family and recreational cross-border travel", urgency: "Year-round steady demand from energy support businesses", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "DSU study abroad in Spain, Italy, Germany, and UK, faculty research conferences, Badlands-to-Alps adventure travelers", urgency: "Academic calendar-driven — August and January peaks", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "DSU international partnerships with Japanese and Chinese universities, energy technology procurement trips, Dickinson families visiting relatives abroad", urgency: "Academic and business timelines — 4-8 week planning", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Winter vacation getaways from North Dakota winters, destination weddings, resort trips through Denver connections", urgency: "Fall and winter vacation bookings", icon: "ri-map-pin-2-line" },
      { name: "South America", context: "DSU agricultural research partnerships in Brazil and Argentina, eco-tourism and adventure travel from Badlands enthusiasts", urgency: "Research calendar and seasonal travel", icon: "ri-map-pin-2-line" },
      { name: "Middle East", context: "Bakken energy conferences, equipment and technology partnerships in UAE and Saudi Arabia", urgency: "Energy industry timelines — often short notice", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other North Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Peace Garden State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Bismarck", route: "/cities/bismarck" },
      { name: "Williston", route: "/cities/williston" },
      { name: "Minot", route: "/cities/minot" },
    ],
  },
  photoLocations: [
    { name: "Dickinson Post Office", address: "15 1st St E, Dickinson, ND 58601", hours: "Mon-Fri 9 AM - 3:30 PM (photo service available)", website: "https://tools.usps.com/find-location.htm" },
    { name: "Walmart Supercenter — Dickinson", address: "2456 3rd Ave W, Dickinson, ND 58601", hours: "Daily 6 AM - 11 PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Dickinson", address: "200 14th St W, Dickinson, ND 58601", hours: "Daily 8 AM - 10 PM", website: "https://www.walgreens.com/" },
    { name: "The UPS Store — Dickinson", address: "387 15th St W, Dickinson, ND 58601", hours: "Call for hours", website: "https://www.theupsstore.com/" },
    { name: "Belfield Post Office", address: "210 Main St N, Belfield, ND 58622", hours: "Mon-Fri 9 AM - 3 PM", website: "https://tools.usps.com/find-location.htm" },
  ],
  dmvLocations: [
    {
      name: "North Dakota DOT — Dickinson Driver License Office",
      address: "1700 3rd Ave W, Suite 101, Dickinson, ND 58601",
      hours: "Mon-Fri, 8:00 AM - 4:45 PM (appointment recommended)",
      note: "Driver licenses, REAL ID, vehicle registration. Serves Stark County. Located in the Prairie Hills Mall area.",
      featured: true,
    },
    {
      name: "Stark County Treasurer — Motor Vehicle",
      address: "51 3rd St E, Dickinson, ND 58601",
      hours: "Mon-Fri, 8:00 AM - 4:30 PM",
      note: "Vehicle registration and title services. For driver licenses, visit the ND DOT office on 3rd Ave W.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DIK",
      name: "Dickinson Theodore Roosevelt Regional Airport",
      distance: "About 5 miles south of downtown Dickinson",
      address: "1130 113th Ave SW, Dickinson, ND 58601",
      note: "Daily United Airlines flights to Denver International Airport. Named after President Theodore Roosevelt, reflecting Dickinson's role as gateway to Theodore Roosevelt National Park. Primary air connection for Stark County to global destinations via Denver.",
      flightUrl: "https://www.dickinsonairport.com/",
      flightLabel: "Dickinson Airport Website",
      featured: true,
    },
    {
      code: "BIS",
      name: "Bismarck Airport",
      distance: "About 100 miles east of Dickinson (1 hour 30 minutes via I-94)",
      address: "2301 University Dr, Bismarck, ND 58504",
      note: "Larger regional airport with additional connections to Minneapolis, Denver, Dallas, and seasonal routes. Alternative for Dickinson travelers needing more flight options.",
      flightUrl: "https://www.bismarckairport.com/",
      flightLabel: "Bismarck Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified North Dakota birth certificates from the ND Department of Health Vital Records. Online, mail, or in-person options available in Bismarck.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through ND Department of Health Vital Records. Required for estate and legal matters in Stark County.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Stark County Clerk of Court. Certified copies available for name changes and passport applications.",
      url: "https://www.starkcountynd.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Stark County District Court. Required for name change passport corrections.",
      url: "https://www.starkcountynd.gov/",
    },
  ],
};